import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/** Keeps the primary purchase controls reachable after they leave the viewport. */
class StickyAtcBar extends Component {
  #abortController = new AbortController();
  #intersectionObserver;
  #primaryQuantityInput;

  connectedCallback() {
    super.connectedCallback();

    const section = this.closest('.shopify-section');
    const primaryBuyButtons = section?.querySelector('.buy-buttons-block');
    this.#primaryQuantityInput = primaryBuyButtons?.querySelector('input[name="quantity"]');

    if (!section || !primaryBuyButtons) return;

    const { signal } = this.#abortController;
    section.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#onQuantityUpdate, { signal });
    section.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });

    this.#syncQuantity(this.#primaryQuantityInput?.value);

    this.#intersectionObserver = new IntersectionObserver(([entry]) => {
      this.hidden = entry.isIntersecting;
    });
    this.#intersectionObserver.observe(primaryBuyButtons);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
    this.#intersectionObserver?.disconnect();
  }

  #onQuantityUpdate = (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;

    const quantity = event.detail?.quantity;
    if (!Number.isFinite(quantity)) return;

    if (this.contains(event.target)) {
      if (this.#primaryQuantityInput) this.#primaryQuantityInput.value = String(quantity);
      return;
    }

    this.#syncQuantity(String(quantity));
  };

  #onVariantUpdate = (event) => {
    if (event.detail?.data?.productId !== this.dataset.productId && !event.detail?.data?.newProduct) return;

    const image = event.detail?.resource?.featured_media?.preview_image;
    const productImage = this.querySelector('[ref="productImage"]');
    if (image?.src && productImage instanceof HTMLImageElement) {
      productImage.src = `${image.src}&width=160`;
      productImage.srcset = '';
      productImage.alt = image.alt || productImage.alt;
    }

    const newPrice = event.detail?.data?.html?.querySelector('.sticky-atc__price');
    const currentPrice = this.querySelector('.sticky-atc__price');
    if (newPrice && currentPrice) currentPrice.textContent = newPrice.textContent;

    const variantId = this.querySelector('[ref="variantId"]');
    if (variantId && event.detail?.resource?.id) {
      variantId.value = String(event.detail.resource.id);
    }
  };

  #syncQuantity(value) {
    const stickyQuantityInput = this.querySelector('input[name="quantity"]');
    if (stickyQuantityInput instanceof HTMLInputElement && value) stickyQuantityInput.value = value;
  }
}

if (!customElements.get('sticky-atc-bar')) {
  customElements.define('sticky-atc-bar', StickyAtcBar);
}
